<template>
  <div
    class="chat-question chat-bubble"
    v-bind:class="{
      'from-customer': message.DIRECTION === 'customer2club',
      'from-club': message.DIRECTION === 'club2customer',
    }"
  >
    <MessageDate :timestamp="message.TIMESTAMP"> </MessageDate>
    <p>{{ message.DATA_TEXT }}</p>
    <div class="answers">
      <template v-for="(answerObj, index) in message.question_buttons">
        <oeamtc-button
          tag="button"
          class="oeamtc-button--magic-black"
          v-bind:key="message.question_id + '-' + index"
          :disabled="submitDisabled"
          @click="answer(answerObj)"
        >
          {{ answerObj.answer_text }}
        </oeamtc-button>
      </template>
    </div>
  </div>
</template>

<script>
import { OeamtcButton } from '@oeamtc/styleguide-vuejs-lib-ui';
import MessageDate from '../MessageDate.vue';
import axios from 'axios';

export default {
  name: 'QuestionItem',
  props: ['message', 'token'],
  components: {
    MessageDate,
    OeamtcButton,
  },
  data() {
    return {
      submitDisabled: false,
    };
  },
  methods: {
    answer(answerObj) {
      if (answerObj) {
        this.submitDisabled = true;
        axios
          .post(
            `${process.env.VUE_APP_API_URL}/msg/assistance/incident/${this.token}/answer`,
            {
              answer: {
                question_element_id: this.message.question_id,
                text: answerObj.answer_text,
              },
            }
          )
          .then(
            () => {
              this.submitDisabled = false;
              this.showModal = false;
            },
            (error) => {
              console.error(error);
              this.submitDisabled = false;
            }
          );
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.answers {
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  button {
    margin: 10px 0;

    &:first-child {
      margin-top: 0;
    }

    &:last-child {
      margin-bottom: 0;
    }
  }
}
</style>
